import { SelectionType } from "@dextall/panel-hooks-editor-2d";
import {
    findPredefinedCladdingDepthIndex,
    findPredefinedSheetMetallThicknessIndex,
    predefinedCladdingDepths,
    predefinedSheetMetallThicknesses,
} from "@dextall/panels-defaults";
import { CladdingCellStyle, GrainDirection } from "../../../../responses/panelSource";
import { noop } from "../../../shared";
import { ImperialAndMetricDimensionEditor } from "../../editor-inputs/imperialAndMetricDimensionEditor";
import { RalColorPropertyEditor } from "../../editor-inputs/ralColorPropertyEditor";
import { TextPropertyEditor } from "../../editor-inputs/textPropertyEditor";
import { PanelEditorScope } from "../../panels/panel-editor-scope";
import { Parameters } from "./parameters";
import { usePanelSelectedComponent } from "./usePanelSelectedComponentHook";

type Props = {
    panelEditorScope: PanelEditorScope;
};

export const PanelCladdingCellPropertiesDockingPanelContent = ({ panelEditorScope }: Props) => {
    const { panel, selection } = usePanelSelectedComponent(panelEditorScope);

    if (!(panel && selection && selection.type === SelectionType.CladdingCell)) {
        return null;
    }

    const claddingCell = panel.claddingCells[selection.index];

    return (
        <div className="fullheight">
            <Parameters>
                <RalColorPropertyEditor label="Color:" ralColor={claddingCell.color} disabled />
                {claddingCell.style !== CladdingCellStyle.Acm && (
                    <>
                        <TextPropertyEditor
                            title="Depth:"
                            value={predefinedCladdingDepths[findPredefinedCladdingDepthIndex(claddingCell.depth)].name}
                            onChange={noop}
                            disabled
                        />

                        <TextPropertyEditor
                            title="Material:"
                            value={
                                predefinedSheetMetallThicknesses[
                                    findPredefinedSheetMetallThicknessIndex(claddingCell.sheetMetalThickness)
                                ].name
                            }
                            onChange={noop}
                            disabled
                        />
                    </>
                )}
                {claddingCell.style === CladdingCellStyle.Acm && (
                    <>
                        <RalColorPropertyEditor label="Rivet color:" ralColor={claddingCell.rivetColor} disabled />

                        <TextPropertyEditor
                            title="Grain dir.:"
                            value={claddingCell.grainDirection === GrainDirection.Vertical ? "Vertical" : "Horizontal"}
                            onChange={noop}
                            disabled
                        />

                        <TextPropertyEditor title="Material:" value="ACM" onChange={noop} disabled />
                    </>
                )}
                <TextPropertyEditor
                    title="Top flange angle:"
                    value={`${claddingCell.topFlangeAngle}°`}
                    onChange={noop}
                    disabled
                />
                <ImperialAndMetricDimensionEditor
                    value={claddingCell.width}
                    onChange={noop}
                    title="Width:"
                    disabled={true}
                />

                <ImperialAndMetricDimensionEditor
                    value={claddingCell.height}
                    onChange={noop}
                    title="Height:"
                    disabled={true}
                />
            </Parameters>
        </div>
    );
};
